import { render, staticRenderFns } from "./NoOffersPlug.vue?vue&type=template&id=8f5868fa&scoped=true&"
import script from "./NoOffersPlug.vue?vue&type=script&lang=js&"
export * from "./NoOffersPlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5868fa",
  null
  
)

export default component.exports